var App = App || {};

App.SharedAccessibility = (function ($) {
    'use strict';

    function init() {
        $(".shared-accessibility #shared-accessibility-main").click(function () {
            var TargetMain = $("main.site-main");
            TargetMain.attr("tabindex", -1).on("blur focusout", function () {
                $(this).removeAttr("tabindex");
            }).focus();
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SharedAccessibility.init();
});